/**
 * Helper pur de nettoyage du `blockingReason` cote UI.
 *
 * S1.9 P2-A : le backend stocke parfois la metadata "was=<status>" en suffixe
 * du blocking_reason pour pouvoir restaurer le status apres unblock. Cette
 * metadata technique ne doit JAMAIS etre exposee dans le UI.
 *
 * Reco S1.9 : fix frontend (rapide). A refactor en S2 cote backend (separer
 * en 2 colonnes blocking_reason vs previous_status), avec migration 013.
 *
 * Patterns observes :
 *   "Comptable injoignable depuis 12 jours, was=collecte"
 *   "Client absent - was=attente_signature"
 *   "Pieces refusees was=pret_generation"
 */

/**
 * Coupe la metadata "was=" du blocking_reason avant affichage.
 *
 * @param {string | null | undefined} reason
 * @returns {string}
 */
export function formatBlockingReason(reason) {
  if (!reason) return '';
  // Match optional whitespace + comma/dash + 'was=<word>' jusqu a la fin de chaine
  return String(reason).replace(/[\s,;-]*\bwas\s*=\s*\w+\s*$/i, '').trim();
}
